export const EXECUTIVE_DECISION_TYPES = Object.freeze({ CAPITAL_ALLOCATION: "EXECUTIVE_CAPITAL_ALLOCATION" });
export const EXECUTIVE_DECISION_PHASES = Object.freeze({ PRE_BUDGET: "PRE_BUDGET", BUDGET_CONSTRAINED: "BUDGET_CONSTRAINED" });
export const EXECUTIVE_DECISION_STATUSES = Object.freeze({ AVAILABLE: "AVAILABLE", INCOMPLETE_EVIDENCE: "INCOMPLETE_EVIDENCE", CONFLICTED: "CONFLICTED", UNAVAILABLE: "UNAVAILABLE" });

function deepFreeze(value) {
  if (!value || typeof value !== "object" || Object.isFrozen(value)) return value;
  Object.values(value).forEach(deepFreeze);
  return Object.freeze(value);
}

export function createExecutiveDecisionAlternative(value) {
  return deepFreeze({
    id: value.id,
    decisionType: EXECUTIVE_DECISION_TYPES.CAPITAL_ALLOCATION,
    scope: "PORTFOLIO",
    ...value,
  });
}
